export type StatusCode =
  | "S112"
  | "S300"
  | "S111"
  | "S120"
  | "S121"
  | "S910"
  | "S911"
  | "S912"
  | "S210"
  | "S220"
  | "S920"
  | "S930";

export const STATUS_FILTER: { [key in StatusCode]: string } = {
  S112: "Not for AI Entry",
  S300: "AI Entry in Progress",
  S111: "AI Entry Done",
  S121: "Review in Progress (Half)",
  S120: "Review in Progress",
  S911: "DB Saved (Half)",
  S910: "DB Saved",
  S912: "Completed",
  S220: "Insert Image",
  S210: "Edit Article",
  S920: "Published",
  S930: "Unsuitable",
};

export const EDITOR_INFO_CODE: { [key in string]: StatusCode } = {
  mcEditorNameInfo: "S112",
  ftEditorNameInfo: "S911",
};
